@if (_active) {
  <kendo-window title="{{'ADD NEW RECORD'}}" (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)" class="fullWidthFormForm">
    <div class="row zeromarginRow so-approval-cycle">
      <div class="col-12 zeroPaddingColumn">
        <div class="row zeromarginRow">
          <div class="col-12">
            <div class="margin-top-15 margin-bottom-15 bordered_sections-approvals">
              <div class="col-12 margin-top-15">
                <h2 class="adminInsideSectionTitle">Follow the Green Light</h2>
              </div>
              <kendo-stepper [steps]="_steps" [stepType]="'full'" [(currentStep)]="_currentStep"
                [linear]="false">
              </kendo-stepper>
            </div>
          </div>
          @if (_currentStep == 0) {
            <div class="col-12 margin-top-15 margin-bottom-15">
              <div class="bordered_sections-approvals contentStepperPages" [class.active]="_currentStep == 0">
                <div class="row zeromarginRow padTopBut-15">
                  <div class="col-12">
                    <h2 class="adminInsideSectionTitle">Enable Cycle</h2>
                  </div>
                  <div class="col-12">
                    <p class="adminInsideSectionstextWithoutpadding">
                      Turning on one or more approvals adds three additional
                      Stock Order Status values.
                    </p>
                    <p class="adminInsideSectionstextWithoutpadding">
                      <span class="dotSpan">.</span>Without approvals , Stock Order Status:Approved
                      -closed
                    </p>
                    <p class="adminInsideSectionstextWithoutpadding">
                      <span class="dotSpan">.</span>With approvals on , Stock Order
                      Status:Open-Pending
                      Approval-Rejected-Approved -closed
                    </p>
                    <p class="adminInsideSectionstextWithoutpadding">
                      <span class="dotSpan">.</span>If you have existing SOs included in enabled
                      approvals cycles, and you
                      disable
                      the concerned cycles, the SO status will change from open to Approved.The rest
                      of
                      the
                      SOs will retain their status.
                    </p>
                    <p class="adminInsideSectionstextWithoutpadding">
                      <span class="dotSpan">.</span>You cannot edit a cycle when any of the included
                      SOs has a pending status
                    </p>
                  </div>
                  <div class="col-12">
                    <div class="adminInsideSectionsSeperator"></div>
                  </div>
                  <div class="col-12">
                    <h2 class="adminInsideSectionTitle">Enable Approval Cycle</h2>
                  </div>
                  <div class="col-12 margin-top-15">
                    <div class="approval-cycle-form-row">
                      <label class="control-label">Approval Cycle Code</label>
                      <div class="form-control-container">
                        <input #cycleCode type="text" class="k-textbox writebox full-width"
                          placeholder="Enter approval cycle code"
                          [disabled]="_isPendingSalesOrder"
                          [(ngModel)]="approvalCycleCode" [ngModelOptions]="{standalone: true}"
                          (keydown.Tab)="OpenSiteComboBox()" />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 margin-top-15 site-names-style">
                      <div class="approval-cycle-form-row">
                        <label class="control-label" for="siteNames">Site Name</label>
                        <div class="form-control-container customMultiSelectList customMultiSelectListApprovals">
                          <kendo-multiselect #kendo_multiselect
                            [summaryTagAfter]="0"
                            class="customMultiSelect app-cycle_controls full-width" name="siteNames"
                            placeholder="Sites" [autoClose]="false"
                            [disabled]="_isPendingSalesOrder"
                            [data]="sites" [textField]="'name'" [valueField]="'id'"
                            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedSites"
                            [itemDisabled]="isItemDisabled.bind(this)"
                            (valueChange)="SiteNameSelected($event)">
                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                              <input type="checkbox" class="k-checkbox"
                                [checked]="isItemSelected(dataItem.id)">
                                <label class="k-checkbox-label">{{ dataItem.name }}</label>
                              </ng-template>
                            </kendo-multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 margin-top-15">
                        <div class="approval-cycle-form-row">
                          <label class="control-label">Status</label>
                          <div class="form-control-container display-flex gap-20 align-items-center">
                            <label class="custom-radio-label">
                              <input type="radio" name="soStatusRadio" [value]="true"
                                [disabled]="_isPendingSalesOrder"
                                [checked]="isEnable === true"
                                (change)="onStatusRadioChange(true)" />
                                <span>Enable</span>
                              </label>
                              <label class="custom-radio-label">
                                <input type="radio" name="soStatusRadio" [value]="false"
                                  [disabled]="_isPendingSalesOrder"
                                  [checked]="isEnable === false"
                                  (change)="onStatusRadioChange(false)" />
                                  <span>Disable</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (_currentStep == 1) {
                    <div class="col-12 margin-top-15 margin-bottom-15">
                      <div class="bordered_sections-approvals contentStepperPages" [class.active]="_currentStep == 1">
                        <div class="row zeromarginRow padTopBut-15">
                          <div class="col-12">
                            <h2 class="adminInsideSectionTitle">Assign Customer(s)</h2>
                          </div>
                          <div class="col-12">
                            <p class="adminInsideSectionstextWithoutpadding">
                              Note Customer Already selected in other approved cycle will not be saved
                            </p>
                          </div>
                          <div class="col-12 zeroPaddingColumn">
                            <asap-fields-select-from-boxes [title]="'Customers'"
                              [disabled]="_isPendingSalesOrder"
                              [fields]="customers" [selectedFields]="selectedCustomers"
                              [displayFieldName]="'code'" [fullWidth]="true" [showFilters]="false" (selectedFieldsOutput)="GetSelectedCustomers($event)">
                            </asap-fields-select-from-boxes>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (_currentStep == 2) {
                    <div class="col-12 margin-top-15 margin-bottom-15">
                      <div class="bordered_sections-approvals contentStepperPages" [class.active]="_currentStep == 2">
                        <div class="row zeromarginRow padTopBut-15">
                          <div class="col-12">
                            <h2 class="adminInsideSectionTitle">
                              Would you want the "Creator of the SO" to
                              receive Notifications?
                            </h2>
                          </div>
                          <div class="col-12 margin-top-15">
                            <label class="control-label Large-Width-Label">Notification Options</label>
                            <div class="display-flex gap-20 align-items-center margin-top-5">
                              <label class="custom-radio-label">
                                <input type="radio" name="soNotificationOptionRadio" value="Yes"
                                  [disabled]="_isPendingSalesOrder"
                                  [checked]="_currentNotificationOption === 'Yes'"
                                  (change)="_notificationOptionChange('Yes')" />
                                  <span>Yes</span>
                                </label>
                                <label class="custom-radio-label">
                                  <input type="radio" name="soNotificationOptionRadio" value="No"
                                    [disabled]="_isPendingSalesOrder"
                                    [checked]="_currentNotificationOption === 'No'"
                                    (change)="_notificationOptionChange('No')" />
                                    <span>No</span>
                                  </label>
                                </div>
                              </div>
                              <ng-container>
                                @if (_currentNotificationOption && _currentNotificationOption=='Yes') {
                                  <div class="col-12 margin-top-15">
                                    <div class="row zeromarginRow">
                                      <div class="col-12 zeroPaddingColumn">
                                        <div class="adminInsideSectionsSeperator"></div>
                                      </div>
                                      <div class="col-12 zeroPaddingColumn margin-top-15">
                                        <h2 class="adminInsideSectionTitle">
                                          How would you like the "Creator" to
                                          receive notifications on Pending , Approved and Rejected Requests?
                                        </h2>
                                      </div>
                                      <div class="col-12 zeroPaddingColumn margin-top-15">
                                        <label class="control-label Large-Width-Label">
                                          Request "Pending" Notification
                                        </label>
                                        <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                          @for (option of _pendingNotification; track option) {
                                            <label class="custom-radio-label">
                                              <input type="radio" name="soCreatorPendingRadio" [value]="option"
                                                [disabled]="_isPendingSalesOrder"
                                                [checked]="creatorEmail === option"
                                                (change)="PendingRequestNotification(option)" />
                                                <span>{{ option }}</span>
                                              </label>
                                            }
                                          </div>
                                        </div>
                                        <div class="col-12 zeroPaddingColumn margin-top-15">
                                          <label class="control-label Large-Width-Label">
                                            Request "Approved" Notification
                                          </label>
                                          <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                            @for (option of _notification; track option) {
                                              <label class="custom-radio-label">
                                                <input type="radio" name="soCreatorApprovedRadio" [value]="option"
                                                  [disabled]="_isPendingSalesOrder"
                                                  [checked]="approvesCreator === option"
                                                  (change)="ApprovedRequestNotification(option)" />
                                                  <span>{{ option }}</span>
                                                </label>
                                              }
                                            </div>
                                          </div>
                                          <div class="col-12 zeroPaddingColumn margin-top-15">
                                            <label class="control-label Large-Width-Label">
                                              Request "Rejected" Notification
                                            </label>
                                            <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                              @for (option of _notification; track option) {
                                                <label class="custom-radio-label">
                                                  <input type="radio" name="soCreatorRejectedRadio" [value]="option"
                                                    [disabled]="_isPendingSalesOrder"
                                                    [checked]="rejectsCreator === option"
                                                    (change)="RejectedRequestNotification(option)" />
                                                    <span>{{ option }}</span>
                                                  </label>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (_currentStep == 3) {
                              <div class="col-12 margin-top-15 margin-bottom-15">
                                <div class="bordered_sections-approvals contentStepperPages" [class.active]="_currentStep == 3">
                                  <div class="row zeromarginRow padTopBut-15">
                                    <div class="col-12">
                                      <h2 class="adminInsideSectionTitle">
                                        How many "Approver(s)/Person(s)" would you
                                        assign for the designated SO?
                                      </h2>
                                    </div>
                                    <div class="col-12 margin-top-15">
                                      <div class="row zeromarginRow">
                                        <div class="col-12 col-lg-8 zeroPaddingColumn">
                                          <label class="control-label Large-Width-Label">Number of Approvers</label>
                                          <div class="display-flex gap-20 align-items-center margin-top-5">
                                            <label class="custom-radio-label">
                                              <input type="radio" name="soNumApproversRadio" [value]="1"
                                                [disabled]="_isPendingSalesOrder"
                                                [checked]="_approverNumberValue === 1"
                                                (change)="_approverNumberChange(1)" />
                                                <span>1 Approver</span>
                                              </label>
                                              <label class="custom-radio-label">
                                                <input type="radio" name="soNumApproversRadio" [value]="2"
                                                  [disabled]="_isPendingSalesOrder"
                                                  [checked]="_approverNumberValue === 2"
                                                  (change)="_approverNumberChange(2)" />
                                                  <span>2 Approvers</span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        @if (_approverNumberValue==1 || _approverNumberValue==2) {
                                          <div class="col-12 margin-top-15"
                                            >
                                            <div class="row zeromarginRow">
                                              <div class="col-12 zeroPaddingColumn">
                                                <div class="adminInsideSectionsSeperator"></div>
                                              </div>
                                              @if (_approverNumberValue==1 || _approverNumberValue==2) {
                                                <div class="col-12 col-lg-6 zeroPaddingColumn margin-top-15"
                                                  >
                                                  <div class="row zeromarginRow">
                                                    @if (_approverNumberValue==1) {
                                                      <div class="col-12 zeroPaddingColumn">
                                                        <h2 class="adminInsideSectionTitle">Approver</h2>
                                                      </div>
                                                    }
                                                    @if (_approverNumberValue==2) {
                                                      <div class="col-12 zeroPaddingColumn margin-top-15"
                                                        >
                                                        <h2 class="adminInsideSectionTitle">Approver 1</h2>
                                                      </div>
                                                    }
                                                    <div class="col-12 zeroPaddingColumn margin-top-15">
                                                      <h2 class="adminInsideSectionTitle">
                                                        Who is the "1st Approver" to be?
                                                      </h2>
                                                    </div>
                                                    <div class="col-12 zeroPaddingColumn margin-top-15">
                                                      <label class="control-label Large-Width-Label">
                                                        Choose The 1st Approver
                                                      </label>
                                                      <div class="radio-group-vertical margin-top-5">
                                                        @for (item of _firstApprover; track item) {
                                                          <label class="custom-radio-label">
                                                            <input type="radio" name="soFirstApproverRadio" [value]="item.field"
                                                              [disabled]="_isPendingSalesOrder"
                                                              [checked]="firstApprover?.field === item.field"
                                                              (change)="PickApprover(item)" />
                                                              <span>{{ item.displayName }}</span>
                                                            </label>
                                                          }
                                                        </div>
                                                      </div>
                                                      @if (firstApprover?.field == 'isPerson1') {
                                                        <div class="col-12 zeroPaddingColumn margin-top-15"
                                                          >
                                                          <label class="control-label Large-Width-Label">Choose Person</label>
                                                          <kendo-combobox #person1ComboBox [data]="personsFiltered1"
                                                            [filterable]="true"
                                                            [disabled]="_isPendingSalesOrder"
                                                            class="current-step app-cycle_controls halfWidthCombo"
                                                            (valueChange)="onPersonsGridSelectionChange($event, 1)"
                                                            (filterChange)="handlePersonItemsFilter($event, 1)"
                                                            [(ngModel)]="selectedPerson1Item" [ngModelOptions]="{standalone: true}" [suggest]="true"
                                                            [placeholder]="'Choose a person'" [textField]="'code'"
                                                            [valueField]="'id'" required>
                                                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                              <div class="choose-person-dropdown-item">
                                                                <div class="truncate">
                                                                  {{ dataItem.code }}
                                                                </div>
                                                                <div class="choose-person-dropdown-item-description truncate">
                                                                  {{dataItem.firstName || ''}} {{
                                                                  dataItem.lastName ||
                                                                  ''
                                                                  }}
                                                                </div>
                                                              </div>
                                                            </ng-template>
                                                          </kendo-combobox>
                                                        </div>
                                                      }
                                                      <div class="col-12 zeroPaddingColumn margin-top-30">
                                                        <h2 class="adminInsideSectionTitle">
                                                          How should the "1st Approver"
                                                          receive notifications on Pending , Approved and Rejected
                                                          Requests?
                                                        </h2>
                                                      </div>
                                                      <div class="col-12 zeroPaddingColumn margin-top-15">
                                                        <label class="control-label Large-Width-Label">
                                                          Request "Approved" Notification
                                                        </label>
                                                        <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                                          @for (option of _notification; track option) {
                                                            <label class="custom-radio-label">
                                                              <input type="radio" name="soFirstApprovedNotification" [value]="option"
                                                                [disabled]="_isPendingSalesOrder"
                                                                [checked]="approval1Approver1ApprovesApprover1 === option"
                                                                (change)="ApproverConfiguration(option, 'approved', 1)" />
                                                                <span>{{ option }}</span>
                                                              </label>
                                                            }
                                                          </div>
                                                        </div>
                                                        <div class="col-12 zeroPaddingColumn margin-top-15">
                                                          <label class="control-label Large-Width-Label">
                                                            Request "Rejected" Notification
                                                          </label>
                                                          <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                                            @for (option of _notification; track option) {
                                                              <label class="custom-radio-label">
                                                                <input type="radio" name="soFirstRejectNotification" [value]="option"
                                                                  [disabled]="_isPendingSalesOrder"
                                                                  [checked]="approval1Approver1RejectsApprover1 === option"
                                                                  (change)="ApproverConfiguration(option, 'rejected', 1)" />
                                                                  <span>{{ option }}</span>
                                                                </label>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    @if (_approverNumberValue==2) {
                                                      <div class="col-12 col-lg-6 zeroPaddingColumn margin-top-15"
                                                        >
                                                        <div class="row zeromarginRow">
                                                          <div class="col-12 zeroPaddingColumn margin-top-15">
                                                            <h2 class="adminInsideSectionTitle">Approver 2</h2>
                                                          </div>
                                                          <div class="col-12 zeroPaddingColumn margin-top-15">
                                                            <h2 class="adminInsideSectionTitle">
                                                              Who is the "2nd Approver" to be?
                                                            </h2>
                                                          </div>
                                                          <div class="col-12 zeroPaddingColumn margin-top-15">
                                                            <label class="control-label Large-Width-Label">
                                                              Choose The 2nd Approver
                                                            </label>
                                                            <div class="radio-group-vertical margin-top-5">
                                                              @for (item of _sndApprover; track item) {
                                                                <label class="custom-radio-label">
                                                                  <input type="radio" name="soSecondApproverRadio" [value]="item.field"
                                                                    [disabled]="_isPendingSalesOrder"
                                                                    [checked]="sndApprover?.field === item.field"
                                                                    (change)="PickApprover(item)" />
                                                                    <span>{{ item.displayName }}</span>
                                                                  </label>
                                                                }
                                                              </div>
                                                            </div>
                                                            @if (sndApprover?.field == 'isPerson2') {
                                                              <div class="col-12 zeroPaddingColumn margin-top-15"
                                                                >
                                                                <label class="control-label Large-Width-Label">Choose Person</label>
                                                                <kendo-combobox #person2ComboBox [data]="personsFiltered2"
                                                                  [filterable]="true"
                                                                  [disabled]="_isPendingSalesOrder"
                                                                  class="current-step app-cycle_controls halfWidthCombo"
                                                                  (valueChange)="onPersonsGridSelectionChange($event, 2)"
                                                                  (filterChange)="handlePersonItemsFilter($event, 2)"
                                                                  [(ngModel)]="selectedPerson2Item" [ngModelOptions]="{standalone: true}"
                                                                  [suggest]="true" [placeholder]="'Choose a person'" [textField]="'code'"
                                                                  [valueField]="'id'" required>
                                                                  <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                                    <div class="choose-person-dropdown-item">
                                                                      <div class="truncate">
                                                                        {{ dataItem.code }}
                                                                      </div>
                                                                      <div class="choose-person-dropdown-item-description truncate">
                                                                        {{dataItem.firstName || ''}} {{
                                                                        dataItem.lastName ||
                                                                        ''
                                                                        }}
                                                                      </div>
                                                                    </div>
                                                                  </ng-template>
                                                                </kendo-combobox>
                                                              </div>
                                                            }
                                                            <div class="col-12 zeroPaddingColumn margin-top-30">
                                                              <h2 class="adminInsideSectionTitle">
                                                                How should the "2nd Approver"
                                                                receive notifications on Pending , Approved and Rejected
                                                                Requests?
                                                              </h2>
                                                            </div>
                                                            <div class="col-12 zeroPaddingColumn margin-top-15">
                                                              <label class="control-label Large-Width-Label">
                                                                Request "Approved" Notification
                                                              </label>
                                                              <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                                                @for (option of _notification; track option) {
                                                                  <label class="custom-radio-label">
                                                                    <input type="radio" name="soSecondApprovedNotification" [value]="option"
                                                                      [disabled]="_isPendingSalesOrder"
                                                                      [checked]="approval2ApprovesApprover2 === option"
                                                                      (change)="ApproverConfiguration(option, 'approved', 2)" />
                                                                      <span>{{ option }}</span>
                                                                    </label>
                                                                  }
                                                                </div>
                                                              </div>
                                                              <div class="col-12 zeroPaddingColumn margin-top-15">
                                                                <label class="control-label Large-Width-Label">
                                                                  Request "Rejected" Notification
                                                                </label>
                                                                <div class="display-flex gap-15 align-items-center radio-group-inline margin-top-5">
                                                                  @for (option of _notification; track option) {
                                                                    <label class="custom-radio-label">
                                                                      <input type="radio" name="soSecondRejectNotification" [value]="option"
                                                                        [disabled]="_isPendingSalesOrder"
                                                                        [checked]="approval2RejectsApprover1 === option"
                                                                        (change)="ApproverConfiguration(option, 'rejected', 2)" />
                                                                        <span>{{ option }}</span>
                                                                      </label>
                                                                    }
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          }
                                                        </div>
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                          <div class="row zeromarginRow">
                                            <div class="col-12 margin-top-15">
                                              @if (_currentStep == 3 || (isEditMode && isEnable === false)) {
                                                <button kendoButton class="steps_buttons_class"
                                                  [disabled]="_isPendingSalesOrder"
                                                  (click)="_onSave($event)">
                                                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                                  <span>save</span>
                                                </button>
                                              }
                                              @if (_currentStep < 3) {
                                                <button kendoButton class="steps_buttons_class" (click)="NavigateToTheNextStep()">
                                                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/next-icon.svg'" />
                                                  <span>Next</span>
                                                </button>
                                              }
                                              @if (_currentStep > 0 && _currentStep < 4) {
                                                <button kendoButton class="steps_buttons_class"
                                                  (click)="previousStep()">
                                                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/back-icon.svg'" />
                                                  <span>Back</span>
                                                </button>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </kendo-window>
                                  }
